import { isEmptyData } from '../../../utils/helper';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ImageLoader from '../../../components/ImageLoader';
import Outlet from '../Outlet';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import Loader from '../../../components/Loader';
import { getCategoryDetail } from '../../../store/reducers/category';
import Search from '../../Header/Search';
import { ListCategory } from '..';
import Tags from '../../Tags';

const CategoryDetail = (props) => {
	const { id, image, onClose } = props;
	const dispatch = useDispatch();

	const user = useSelector((store) => store.user);
	const { detail, isLoadingDetail } = useSelector((store) => store.category);
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [selectedTag, setSelectedTag] = useState(null);

	const handleGetDetail = async (category, tag) => {
		try {
			dispatch(
				getCategoryDetail({
					id: category,
					latitude: user?.latitude,
					longitude: user?.longitude,
					tag,
				}),
			);
		} catch (error) {
			console.log('error: ', error);
		}
	};

	useEffect(() => {
		if (isEmptyData(id)) return;
		setSelectedCategory(id);
	}, [id]);

	useEffect(() => {
		if (isEmptyData(selectedCategory) && isEmptyData(selectedTag)) return;
		handleGetDetail(selectedCategory, selectedTag);
	}, [selectedCategory, selectedTag]);

	const outletProps = {
    outlets: detail?.outlets || [],
  };

	const searchProps = {
		firstClassName: '!relative !w-full md:!max-w-full',
		secondClassName: '!px-0',
		thirdClassName: '!shadow-none border-solid !rounded-full',
	};

	const listCategoryProps = {
		id,
		firstClassName: 'mt-4',
    secondClassName: '',
    thirdClassName: 'ml-1',
		callback: (c) => setSelectedCategory(c),
	};

	const tagProps = {
		isUseStore: false,
		callback: (c) => setSelectedTag(c),
	};

	return (
		<div className='flex flex-col min-h-screen relative bg-white'>
			{isLoadingDetail && <Loader overlay />}
			<div className={`bg-white p-4 flex flex-row items-center border-b-1 border-solid border-gray-200 sticky top-0 min-w-full min-h-10`}>
				<div className='flex flex-row items-center w-full'>
					<ArrowLeftIcon className={`h-8 w-8 transition-all duration-500 text-gray-900 p-1`} onClick={onClose} />
					<Search {...searchProps} />
				</div>
			</div>
			<ListCategory {...listCategoryProps} />
			<Tags {...tagProps} />
			<div className='flex-1 overflow-x-hidden overflow-y-scroll'>
				<Outlet {...outletProps} />
			</div>
		</div>
	);
};

export default CategoryDetail;
